<template>
  <div>
    <!-- 土地的信息 -->
    <div class="land-info">
      <div class="top">
        <div class="item" v-for="item in landInfo" :key="item.key">
          <div class="value">{{ item.value }}</div>
          <div class="label">{{ item.label }}</div>
        </div>
      </div>
      <div class="bottom">
        <span> <span style="color:#3364DB; font-weight: bold;">当前生育期：</span><span style="color:#3364DB">{{ bearDateText
        }}</span></span>
        <span>
          <!-- <img src="../../../../assets/images/set.png" @click="handleSetting" /> -->
        </span>
      </div>
    </div>
    <!-- 水势传感器 -->
    <div class="card" v-if="!deviceChange">
      <div class="title">灌溉指导</div>
      <div class="p1 fs22" v-for="(item, index) in relist" :key="index">
        <WaterPotentialLine v-if="item.isWater" :currentValue="item.value" :unit="item.unit" :min="item.lowerLimit"
          :middle="item.middle" :max="item.uperLimit" />

        <div class="flex-row items-center justify-between warning ">
          <span>{{ item.name }}</span>
          <span>预警值：{{ item.middle || item.lowerLimit }}~{{ item.uperLimit }}-kPa &nbsp; <img
              src="../../../../assets/images/set.png" @click="handleSetting(index)" /></span>
        </div>
      </div>

    </div>

    <!-- 灌溉指导 -->
    <Diguan v-if="!deviceChange" key="diguan" :cgqList="cgqList" />
    <!-- 生长监测 -->
    <GrowMonitor v-if="!deviceChange" key="GrowMonitor" :farmInfo="farmInfo" :cgqList="cgqList" />
  </div>
</template>

<script>
// 水势组件
import WaterPotentialLine from './waterlLine'
import Diguan from "./diguan.vue"
import GrowMonitor from "./grow.vue"
export default {
  components: {
    WaterPotentialLine, Diguan, GrowMonitor
  },
  props: {
    setting: {
      type: Function,
      default: (item, type) => { },
    },
    callback: {
      type: Function,
      default: (obj) => { },
    },
    hasDeviceChange: {
      type: Boolean,
      default: false,
    },
    refreshing: {
      type: Boolean,
      default: false,
    },
  },

  watch: {
    hasDeviceChange (v) {
      if (v) {
        const no = localStorage.getItem('no')
        this.no = no
        this.init()
      }
    },
    refreshing (bl) {
      console.log("刷新刷新刷新");
      bl && this.onRefresh()
    },
  },

  computed: {
    placement () {
      return function (index) {
        let i = index + 1
        if (i % 2 === 0) {
          return 'left'
        } else {
          return 'right'
        }
      }
    },
  },

  data () {
    return {
      no: localStorage.getItem('no'),
      isLoading: false,
      relist: [],
      landInfo: [
        { key: 'soil', label: '土壤质地', value: '-' },
        { key: 'year', label: '生产年份', value: '-' },
        { key: 'fruit', label: '植物品种', value: '-' },
        { key: 'fruitYear', label: '植物树龄', value: '-' },
      ],
      bearDateText: '', // 生育期
      farmInfo: {},
      cgqList: [],
      deviceChange: false
      // showPopover: false
    }
  },

  async created () {
    const no = localStorage.getItem('no')
    this.no = no

    console.log("新的传感器新的传感器新的传感器新的传感器");

    await this.$api.getCgqAttr({ no: this.no })
      .then(res => {
        if (res.errcode == 0) {
          this.cgqList = res?.list

          console.log("this.cgqList:", this.cgqList);
        }
      })

    this.init()

  },

  methods: {
    async init () {
      this.deviceChange = true

      this.$nextTick(() => {
        this.deviceChange = false
      })
      await this.getCgqList(this.no)
      await this.getQueryFarm()
      if (!this.$isblank(this.farmInfo)) {
        this.landInfo[0].value = this.farmInfo?.soil
        this.landInfo[2].value = this.farmInfo?.cropClass?.name
        if (this.farmInfo?.myCropList?.length) {
          const num = this.farmInfo?.myCropList[this.farmInfo.myCropList.length - 1].plantAge
          const year = new Date().getFullYear()

          if (num) {
            const n = (num / 365).toFixed(1)
            this.landInfo[3].value = n + "年"
            // this.landInfo[1].value = Number(year) - Math.floor(n)
            this.landInfo[1].value = year
          } else {
            this.landInfo[1].value = year
            this.landInfo[3].value = "0年"
          }
        }
      }

      console.log("this.farmInfo:", this.farmInfo);
      if (this.farmInfo.cropClass.id) {
        //  查询当前生育期
        this.queryGrowPeriod()
      }

    },

    queryGrowPeriod () {
      this.$api.queryGrowPeriod(this.farmInfo.cropClass.id).then(res => {
        if (res.errcode === 0) {
          const list = res.list

          // 根据时间来判断当前是什么时期
          const now = Date.now()
          list.map(item => {
            if (item.startDate && item.endDate) {
              const st = (new Date().getFullYear() + "-" + item.startDate + ' 00:00:00').replaceAll("-", "/")
              const et = (new Date().getFullYear() + "-" + item.endDate + ' 23:59:59').replaceAll("-", "/")

              console.log("111:", now, st, et);

              if (new Date(st).getTime() <= now && now <= new Date(et).getTime()) {
                this.bearDateText = item?.shortCall
              }
            }
          })
        }
      })
    },
    async getQueryFarm () {
      await this.$api.queryFarm(this.no).then(res => {
        if (res.errcode == 0) {
          this.farmInfo = { ...res.data }

          if ("extData" in this.farmInfo) {
            this.farmInfo.extData = JSON.parse(this.farmInfo.extData)
            if (this.farmInfo.extData?.data) {
              this.relist.map(item => {

                const find = this.farmInfo.extData.data?.find(o => o.channelNo == item.channelNo)
                if (find) {
                  item.middle = find?.ganhan
                } else {
                  item.middle = null
                }
              })
              console.log(" this.relist:", this.relist);
            }

          } else {
            this.farmInfo.extData = {}
          }
        } else {
          this.$toast({
            message: res.errmsg,
            duration: 2000
          })
        }
      })
    },

    async getCgqList (no) {
      await this.$api.getLiveList({ no, limit: 1, startDate: '2020-01-01 00:00:00', endDate: this.$setime(new Date(), 1), })
        .then((res) => {
          if (res.errcode === 0) {
            if (!this.$isblank(res.list)) {
              const list = res.list
              this.retime = list[0].gatherDate
              this.relist = [...list[0].data].map((item, index) => {
                return {
                  isWater: item.oriName === '土壤张力',
                  sort: item.oriName === '土壤张力' ? 888 + index : index,
                  ...item,
                  ...this.changeKpaValue(item.value),
                  showPopover: false,
                }
              })
                .sort((a, b) => a.sort - b.sort)
                .filter(o => o.isWater)

              console.log("1111111:", this.relist);

              // 重新进行排序  选中水势传感器
              this?.callback?.({ solarVoltage: list[0].solar_voltage, voltage: list[0].voltage, retime: list[0].gatherDate, })
            } else {
              this.relist = []
            }
          } else {
            this.relist = []
            // 其他异常
            this.$toast(res.errmsg)
          }
        })
        .catch((err) => {
          this.relist = []
          console.log(err)
          // 其他异常
          this.$toast(this.$t('common.timeout'))
        })
        .finally(() => {
          this.$toast.clear()
        })
    },

    handleSetting (index) {
      sessionStorage.setItem("liveSettingData", JSON.stringify({ ...this.relist?.[index], no: this.no }));
      this.$router.push({
        path: '/cgqSetting',
        query: {
          type: "cgq",

        }

      })
    },

    // 刷新
    async onRefresh () {
      this.init()
    },

    changeKpaValue (v) {
      // "1kpa=1J/kg=0.01Bar=0.001Mpa";
      let p1, p2, p3 = 0, p4 = 0
      p1 = p2 = v
      if (v > 0) {
        p3 = this.pointNum(v, 1)
        p4 = this.pointNum(v, 2)
      } else if (v < 0) {
        p3 = [...v.toString()].splice(2, 0, '00').join('')
        p4 = [...v.toString()].splice(2, 0, '000').join('')
      }
      return {
        p1, p2, p3, p4,
      }
    },

    pointNum (num, type) {
      const arr = [...('0000' + num.toString())]
      const index = arr.indexOf('.')
      // p3 /100  2个0    p4 /1000 3个0
      const mo = type === 1 ? 2 : 3
      if (index > -1) {
        // 有小数点 将小数点前移 2位
        arr.splice(index, 1)
        // +1 是因为上面删除后 长度减1
        arr.splice(index - (mo + 1), 1, '.')
      } else {
        const i = arr.length - 1 - mo
        arr.splice(i, 1, '.')
      }
      return arr.slice(arr.indexOf('.') - 1).join('')
    },
  },
}
</script>
<style>
.kindlists {
  padding: 0;
}
</style>
<style lang="scss" scoped>
@import "../../codeFunCommon.scss";

.pull-refresh {
  width: 100%;
}

.cgq-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.isWater {
  width: 100% !important;
}

.kindlist {
  display: inline-block;
  overflow: hidden;
  width: 48%;
  min-height: 1.4rem;
  padding: 0.24rem 0.2rem;
  border-radius: 0.15rem;
  box-shadow: 0 0 0.1rem rgba(0, 0, 0, 0.05);
  position: relative;
  background: #fff;
  margin-bottom: 0.2rem;
  box-sizing: border-box;
}

.kindlist .kindtop {
  overflow: hidden;
  line-height: 0.26rem;
}

.kindlist .kindtop .kindtop_left {
  float: left;
  font-size: 13px;
  font-weight: bold;
  color: #333333;
}

.ho {
  background: url(../../../../assets/images/red.png) 0 50% no-repeat;
  background-size: 0.22rem 0.22rem;
}

.lv {
  background: url(../../../../assets/images/lv.png) 0 50% no-repeat;
  background-size: 0.22rem 0.22rem;
}

.kindlist .kindtop .kindtop_right {
  float: right;
}

.kindlist .kindtop .kindtop_right img {
  width: 14px;
  height: 14px;
}

.kindlist .kindbot {
  text-align: center;
  color: #666;
}

.kindlist .kindbot .p1 span {
  font-size: 24px;
  font-weight: bold;
}

.kindlist .kindbot .p2 {
  display: flex;
  justify-content: space-between;
  align-content: center;
  padding-top: 0.06rem;
}

.kindlist .kindbot .p1 {
  position: relative;
  padding-top: 0.2rem;
}

.isWater .p1 {
  padding-top: 1rem !important;
}

.formula {
  display: block;
  font-size: 12px;
  padding: 2px 6px;
}

.formula div {
  line-height: 18px;
}

.kindlist .kindbot .p1 .info {
  position: relative;
  top: -10px;
  font-size: 12px;
  color: rgba(53, 105, 233, 0.9);
}

.kindlist .kindbo {
  position: absolute;
  z-index: -1;
  right: 0;
  bottom: 0;
  width: 1.95rem;
  height: 1.03rem;
  line-height: 1.45rem;
  background: url(../../../../assets/images/bo.png) center no-repeat;
  background-size: 100% 100%;
  color: #2855bb;
  text-align: right;
  padding-right: 0.2rem;
}

.kindlist .kindbo.kindbo2 {
  width: 1.98rem;
  line-height: 1.6rem;
  padding-right: 0.12rem;
}

/deep/ .van-popup {
  height: auto;
}

.error {
  display: none;
}

.error2 {
  background: #f56c6c;
  border-radius: 3px;
  color: #ffffff;
  padding: 1px 4px;
}

.normal {
  background: rgba(68, 210, 106, 0.39);
  border-radius: 3px;
  color: #ffffff;
  padding: 1px 4px;
}

.enough {
  background: #409eff;
  border-radius: 3px;
  color: #ffffff;
  padding: 1px 4px;
}

.land-info {
  background: #ffffff;
  margin-left: -0.2rem;
  margin-right: -0.2rem;
  box-sizing: border-box;
  padding: 8px 0.4rem;
  margin-bottom: 15px;

  .top {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .label {
      color: #808d9e;
      font-size: 14px;
      margin-top: 5px;
      text-align: center;
    }

    .value {
      color: #333333;
      text-align: center;
      font-size: 16px;
    }
  }

  .bottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 12px;

    img {
      width: 20px;
      height: 20px;
    }
  }
}

.page {
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
}

.section_2 {
  width: 100%;
}

.pos {}

.section {
  padding: 0 10px;
  background-color: #ffffff;
  border-bottom: solid 0.5px #d9d9d9;
}

.group {
  display: flex;
  padding: 18px 0 16px;
}

.font_1 {
  font-size: 16px;
  font-family: PingFang SC;
  line-height: 15px;
  color: #686868;
}

.font_2 {
  font-size: 14px;
  font-family: PingFang SC;
  line-height: 13px;
  color: #3364db;
}

.text {
  margin-left: 64px;
}

.group_2 {
  margin-left: 48px;
}

.space-x-28>*:not(:first-child) {
  margin-left: 28px;
}

.font_3 {
  font-size: 14px;
  font-family: PingFang SC;
  line-height: 13px;
  color: #40464b;
}

.section_3 {
  background-color: #3364db;
  border-radius: 2px 2px 0px 0px;
  width: 53px;
  height: 3px;
}

.view {
  margin-left: 116px;
}

.group_3 {
  padding: 12px 0 398px;
}

.space-y-300>*:not(:first-child) {
  margin-top: 300px;
}

.group_4 {
  padding: 0 10px;
}

.text_3 {
  line-height: 14.5px;
}

.text_2 {
  color: #3364db;
  font-size: 26px;
  font-family: Roboto;
  line-height: 19px;
}

.text_4 {
  line-height: 14.5px;
}

.section_4 {
  padding: 8px 12px 10px 20px;
  border-radius: 4px;
  height: 32px;
  border: solid 1px #2a85ff;
}

.space-x-14>*:not(:first-child) {
  margin-left: 14px;
}

.text_5 {
  color: #2a85ff;
}

.image {
  width: 9px;
  height: 6px;
}

.group_5 {
  padding: 16px 0 13px;
}

.space-x-60>*:not(:first-child) {
  margin-left: 60px;
}

.image_2 {
  width: 20px;
  height: 20px;
}

.view_2 {
  margin-left: 112px;
}

.card {
  margin-bottom: 20px;
  display: inline-block;
  overflow: hidden;
  width: 100%;
  min-height: 1.4rem;
  padding: 0.24rem 0.2rem;
  border-radius: 0.15rem;
  position: relative;
  background: #fff;
  margin-bottom: 0.2rem;
  box-sizing: border-box;
  padding-bottom: 0;

  .title {
    color: #686868;
    font-family: PingFang SC;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    height: 60px;
  }

  .p1 {
    display: block;
    margin-bottom: 20px;
  }

  .warning {
    margin-top: 30px;
    margin-bottom: 50px;

    img {
      width: 14px;
      height: 14px;
      margin-left: 5px;
    }
  }
}
</style>
